import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { PlatformDescriptor } from "../utils/platform-descriptor";
import { Constraints } from "../constraints";
import { AndroidBridgeBase } from "../mobile/api-services/bridge/android-bridge-base";
import { LogsService } from "../utils/services/logs.service";

declare global {
  interface Window {
    nativeBridge: any;
  }
}

@Injectable()
export class AndroidInternalBodyInterceptor implements HttpInterceptor {
  constructor(
    private bridgeBase: AndroidBridgeBase,
    private logger: LogsService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.shouldHandle(req)) {
      return next.handle(req);
    }

    const requestId = req.headers.get("X-Request-Id") ?? this.bridgeBase.getNextRequestId().toString();
    const requestBody = req.body ?? {};
    try {
      if (window.nativeBridge?.storeRequestData) {
        window.nativeBridge.storeRequestData(requestId, JSON.stringify(requestBody));
      }
    } catch (e) {
      this.logger.log(`[AndroidInternalBodyInterceptor] failed to store request body: ${e}`);
    }

    const headers: HttpHeaders = req.headers.set("X-Request-Id", requestId);
    return next.handle(req.clone({ headers }));
  }

  private shouldHandle(req: HttpRequest<any>): boolean {
    if (environment.platform.name !== PlatformDescriptor.Android.name) return false;
    if (!req.url.startsWith(Constraints.androidGenericInternalApiEndpoint)) return false;
    // CSPA request-based bridge uses /api/... and stores request body on its own.
    // Intercept only /platform/... routes to avoid overwriting CSPA payloads.
    if (!req.url.startsWith(`${Constraints.androidGenericInternalApiEndpoint}/platform/`)) return false;
    return req.method === "POST"
      || req.method === "PUT"
      || req.method === "PATCH"
      || req.method === "DELETE";
  }
}
